import { TwoByOne } from './TwoByOne';

export {
  TwoByOne,
};
